import { render, staticRenderFns } from "./SidebarNavCustom.vue?vue&type=template&id=3efc95f2&scoped=true"
import script from "./SidebarNavCustom.vue?vue&type=script&lang=js"
export * from "./SidebarNavCustom.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavCustom.vue?vue&type=style&index=0&id=3efc95f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efc95f2",
  null
  
)

export default component.exports